// extracted by mini-css-extract-plugin
module.exports = {"navBack":"NavBack_navBack__1H7Ui","customLink":"NavBack_customLink__EL0Xd","arrow":"NavBack_arrow__2LIoZ","left":"NavBack_left__1egi-","customMargin":"NavBack_customMargin__wi_CC"};